import Services from '../Service'

/**
 * Módulo Catálogos do Admin (#52).
 *
 * Ligar/desligar e reenviar e-mail vão às rotas de /api/catalogos, as mesmas
 * do dialog do operador: o admin já passa na checagem de dono, e duplicar as
 * rotas só daria duas portas para a mesma regra.
 */
class AdminCatalogoService extends Services {
  constructor() {
    super()
    this.resource = 'admin/catalogos'
  }

  async getCatalogos(params) {
    return await this.getAPI(this.resource, params)
  }

  async getResumo(params) {
    return await this.getAPI(`${this.resource}/resumo`, params)
  }

  async getFiltros() {
    return await this.getAPI(`${this.resource}/filtros`)
  }

  async getCatalogo(hashid) {
    return await this.getAPI(`${this.resource}/${hashid}`)
  }

  /** Carrinho e histórico chegam depois do detalhe (#53): o carrinho lê o ERP. */
  async getCarrinho(hashid) {
    return await this.getAPI(`${this.resource}/${hashid}/carrinho`)
  }

  async getVisitas(hashid) {
    return await this.getAPI(`${this.resource}/${hashid}/visitas`)
  }

  async getHistorico(hashid) {
    return await this.getAPI(`${this.resource}/${hashid}/historico`)
  }

  /** Link novo com os filtros salvos deste (#54). */
  async renew(hashid, payload) {
    return await this.postAPI(`${this.resource}/${hashid}/renovar`, payload)
  }

  async toggleValid(hashid) {
    try {
      const response = await this._http.patch(
        `catalogos/${hashid}/toggle-valid`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async resendEmail(hashid, id) {
    return await this.postAPI(`catalogos/${hashid}/emails/${id}/reenviar`)
  }
}

export default new AdminCatalogoService()
